export default "__VITE_ASSET__d481475e__"